import React from 'react';
import Header from 'cccisd-header';
import style from './style.css';

const Fortress = window.cccisd.fortress;
const userType = Fortress.user.acting.data_type; // guest, uberadmin, guAdmin, guTeamMember

const HeaderComponent = () => {
    const getPrimaryNavLinks = () => {
        let primaryNavLinks = [
            { url: 'https://www.e-gto.com', label: 'Home' },
            { url: 'https://www.e-gto.com/about', label: 'About' },
        ];
        if (userType === 'guAdmin') {
            primaryNavLinks = [
                { url: 'https://www.e-gto.com', label: 'Home' },
                { url: 'https://www.e-gto.com/about', label: 'About' },
                { url: '/planning', label: 'e-GTO Planning' },
                { url: '/resourcecenter', label: 'Resources' },
                { url: '/manage', label: 'Manage' },
            ];
        }
        if (userType === 'guTeamMember') {
            primaryNavLinks = [
                { url: 'https://www.e-gto.com', label: 'Home' },
                { url: 'https://www.e-gto.com/about', label: 'About' },
                { url: '/planning', label: 'e-GTO Planning' },
                { url: '/resourcecenter', label: 'Resources' },
            ];
        }
        if (userType === 'uberadmin') {
            primaryNavLinks = [
                { url: 'https://www.e-gto.com', label: 'Home' },
                { url: 'https://www.e-gto.com/about', label: 'About' },
                { url: '/resourcecenter', label: 'Resources' },
                { url: '/resources/admin', label: 'Resource Admin' },
                { url: '/manage', label: 'Manage' },
                { url: '/quest', label: 'Data' },
                { url: '/appdefs/logs', label: 'System Logs' },
            ];
        }
        return primaryNavLinks;
    };

    const primaryNavLinks = getPrimaryNavLinks();

    return (
        <>
            <Header
                containerClassName="container-fluid"
                wrapperClassName={style.wrapper}
                logoClassName={style.logo}
                primaryNavLinks={primaryNavLinks}
                showHomeAction={false}
                showAdminAction={Fortress.hasRole('uberadmin')}
            />
            <div className={style.closingBanner}>
                The eGTO platform will close on June 30, 2026. All users should complete work and download documents by
                June 30.
            </div>
        </>
    );
};

export default HeaderComponent;
